import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/app/songs')({
  component: SongsLayout,
})

function SongsLayout() {
  return <Outlet />
}
